import React, { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from './firebase';

export default function Login() {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const ALLOWED_EMAILS = [
  'billywalsh94@hotmail.co.uk',
  'hello@bidsense.io',
  'billy@bidsense.io'
];

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const email = result.user.email;

      if (!ALLOWED_EMAILS.includes(email)) {
        await auth.signOut();
        setError('This account is not authorised to access BidSense.');
        setLoading(false);
        return;
      }
    } catch (err) {
      setError('Sign-in failed. Please try again.');
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--pine)',
      fontFamily: "'Instrument Sans', sans-serif"
    }}>
      <div style={{
        background: 'var(--white)',
        borderRadius: 16,
        padding: '48px 40px',
        maxWidth: 400,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(15,46,36,0.3)'
      }}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:10,marginBottom:32}}>
          <div style={{position:'relative',width:32,height:32,display:'flex',flexDirection:'column',justifyContent:'center',gap:5}}>
            <div style={{width:18,height:9,borderLeft:'3px solid var(--pine)',borderBottom:'3px solid var(--pine)',borderRadius:'0 0 0 3px',transform:'rotate(-45deg) translateX(3px)'}}></div>
            <div style={{width:18,height:9,borderLeft:'3px solid var(--pine)',borderBottom:'3px solid var(--pine)',borderRadius:'0 0 0 3px',transform:'rotate(-45deg) translateX(3px)'}}></div>
            <div style={{position:'absolute',bottom:-3,right:-3,width:8,height:8,background:'var(--brass)',borderRadius:'50%'}}></div>
          </div>
          <div style={{fontFamily:"'Sora',sans-serif",fontSize:22,color:'var(--pine)'}}>
            bid<span style={{fontWeight:800}}>sense</span>
          </div>
        </div>

        <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:20,color:'var(--pine)',marginBottom:8}}>
          Sign in to your dashboard
        </h2>
        <p style={{fontSize:14,color:'var(--grey)',marginBottom:28}}>
          Access your AI buying governance overview
        </p>

        <button
          onClick={handleGoogleSignIn}
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px 20px',
            borderRadius: 8,
            border: '1.5px solid var(--grey-light)',
            background: 'var(--white)',
            color: 'var(--pine)',
            fontSize: 14,
            fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10
          }}
        >
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84c-.21 1.13-.84 2.08-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.33C2.44 15.98 5.48 18 9 18z"/>
            <path fill="#FBBC05" d="M3.97 10.72c-.18-.54-.28-1.12-.28-1.72s.1-1.18.28-1.72V4.95H.96C.35 6.17 0 7.55 0 9s.35 2.83.96 4.05l3.01-2.33z"/>
            <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.95l3.01 2.33C4.68 5.16 6.66 3.58 9 3.58z"/>
          </svg>
          {loading ? 'Signing in...' : 'Sign in with Google'}
        </button>

        {error && (
          <p style={{fontSize:13,color:'var(--red)',marginTop:16}}>{error}</p>
        )}
      </div>
    </div>
  );
}